import { render, staticRenderFns } from "./ListagemCotacaoFrete.vue?vue&type=template&id=7a53198b"
import script from "./ListagemCotacaoFrete.vue?vue&type=script&lang=js"
export * from "./ListagemCotacaoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports